import React from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { Link } from 'react-router-dom'
import UserCard from './components/member_card'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getResourceAuthorization } from '@verzekeringapp-mono/shared/src/state/selectors/resource_authorization'
import useResourceAuthorization from '@verzekeringapp-mono/shared/src/hooks/use_resource_authorization'
import PendingUserCard from './components/pending_member_card'

const ManageMembersScreen = () => {
  const resourceAuthorization = useAppSelector(getResourceAuthorization)
  const { getResourceAuthorizationsManagedByUser, managedResourceAuthorizations, pendingResourceAuthorizations } = useResourceAuthorization()

  React.useEffect(() => {
    if (!resourceAuthorization?.userId) return

    getResourceAuthorizationsManagedByUser(resourceAuthorization?.userId)
  }, [resourceAuthorization])

  return (
    <ScreenWrapper>
      <div className='flex flex-col  md:w-1/3 w-full'>
        <button className={'w-full rounded-md bg-action-primary-background text-action-primary-foreground'}>
          <Link
            to='/mijn-profiel/gebruikers-beheren/uitnodigen'
            className='flex items-center justify-center'
          >
            <p className='py-4 text-action-primary-foreground'>Gebruiker uitnodigen</p>
          </Link>
        </button>

        {managedResourceAuthorizations?.map(managedResourceAuthorization => (
          <UserCard
            {...managedResourceAuthorization}
            key={managedResourceAuthorization.id}
          />
        ))}

        {pendingResourceAuthorizations?.map(pendingResourceAuthorization => (
          <PendingUserCard
            {...pendingResourceAuthorization}
            key={pendingResourceAuthorization.combiNumber}
          />
        ))}
      </div>
    </ScreenWrapper>
  )
}

export default ManageMembersScreen
